//import React from 'react';
//import { makeStyles } from "@mui/styles";
import { AppBar as Bar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import { ToggleSidebar } from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
//import clsx from "clsx";
import theme from '../../../theme';
import RightMenu from "./RightMenu";
//import AppbarStyles from "../../../styles/jss/components/AppbarStyles";
import { drawerWidth } from "../../../styles/aero.js";

//const useStyles = makeStyles(AppbarStyles);

const AppBar = (props) => {
    //const classes = useStyles();
    const sidebar = useSelector(state => state.sidebar);
    const dispatch = useDispatch();

    return (
        <Bar
            position="fixed"

            sx={{
              // transition: theme.transitions.create(['margin', 'width'], {
              //     easing: theme.transitions.easing.easeOut,
              //     duration: theme.transitions.duration.enteringScreen,
              // }),
              ...(sidebar.open && sidebar.screenWidth > theme.breakpoints.values.sm && {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: drawerWidth,
                // transition: theme.transitions.create(['margin', 'width'], {
                //     easing: theme.transitions.easing.sharp,
                //     duration: theme.transitions.duration.leavingScreen,
                // }),
              })
            }}


            // className={clsx(classes.appBar, {
            //     [classes.appBarShift]: sidebar.open && sidebar.screenWidth > theme.breakpoints.values.sm,
            // })}
            color={'default'}
        >
            <Toolbar style={{justifyContent: 'space-between'}}>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    {!sidebar.open && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => dispatch(ToggleSidebar())}
                            size="large">
                            <MenuIcon />
                        </IconButton>
                    )}
                    <Typography variant="h6" noWrap>
                        {props.title}
                    </Typography>
                </Box>
                <div>
                    <RightMenu org={props.org}/>
                </div>
            </Toolbar>
        </Bar>
    );
};

export default AppBar;